import { autoserialize, autoserializeAs } from 'cerialize';
import { OAuthClientModel } from './oauth-client.model';

export class SessionModel {
    @autoserialize public _id: string;
    @autoserialize public updatedAt: Date;
    @autoserializeAs(OAuthClientModel) public oauthClient: OAuthClientModel;
}
